module.exports = __webpack_public_path__ + "img/frame (105).e9e50211.jpg";